document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('filePreviewModal');
  const modalContent = document.getElementById('filePreviewContent');
  let pdfDoc = null;
  let currentPage = 1;
  let totalPages = 0;
  // let scale = 1.5; // Výchozí scale pro zoom
  let scale = 1; // Výchozí scale pro zoom

  if (modal && modalContent) {
    const items = document.querySelectorAll('.file-preview');

    if (items.length > 0) {
      items.forEach((item) => {
        const downloadLinks = item.querySelectorAll('.js-file-download');

        if (downloadLinks.length > 0) {
          downloadLinks.forEach((downloadLink) => {
            downloadLink.addEventListener('click', (event) => {
              event.stopPropagation();
            });
          });
        }

        item.addEventListener('click', (event) => {
          if (event.target.closest('.js-file-download')) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          let fileUrl = item.getAttribute('data-file-url') || '';

          if (fileUrl.startsWith('http://')) {
            if (!fileUrl.includes('qaro.local')) {
              fileUrl = fileUrl.replace('http://', 'https://');
            }
          }

          const extension = fileUrl ? getFileExtension(fileUrl) : '';

          if (!fileUrl) {
            modalContent.innerHTML = '<p>Soubor není dostupný.</p>';
            return;
          }

          // Přidání spinneru před načtením souboru
          const spinner = document.createElement('div');
          spinner.classList.add('spinner');
          modalContent.innerHTML = ''; // Vymaže předchozí obsah
          modalContent.appendChild(spinner); // Přidá spinner do modalContent

          modal.classList.add('is-open');
          document.body.classList.add('is-unscrollable');

          setTimeout(() => {
            modalContent.innerHTML = getPreviewContent(fileUrl, extension);
            if (extension === 'pdf') {
              loadPdfJs(fileUrl);
            }
          }, 300); // Zpoždění pro UX
        });
      });
    }

    const closeButtons = document.querySelectorAll('.js-modal-close');
    if (closeButtons.length > 0) {
      closeButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          modal.classList.remove('is-open');
          document.body.classList.remove('is-unscrollable');
        });
      });
    }

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.classList.remove('is-open');
        document.body.classList.remove('is-unscrollable');
      }
    });

    const getFileExtension = (url) => {
      const parts = url.split('.');
      return parts[parts.length - 1].toLowerCase();
    };

    const downLoadPdf = () => {
      const downloadButton = document.getElementById('downloadPdf');
      console.log('downloadButton', downloadButton);

      if (!downloadButton) {
        return;
      }

      downloadButton.addEventListener('click', (event) => {
        const url = downloadButton.getAttribute('data-url');
        console.log('url', url);
        const a = document.createElement('a');
        a.href = url;
        a.download = url;
        a.target = '_blank';
        a.click();
      });
    };

    const getPreviewContent = (url, extension) => {
      if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'heif', 'avif'].includes(extension)) {
        return `<img src="${url}" alt="File Preview" style="max-width: 100%; max-height: 80vh;">`;
      } else if (extension === 'pdf') {
        // HTML pro PDF náhled s tlačítky pro přepínání stránek a zoom
        return `
          <div class="pdfControls pdfControls__top">
            <button id="zoomOut" class="btn btn--compact">
              <span class="icon icon--icon-zoom-out">
                <svg class="icon__svg" viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5zm-4.5 8h9v1h-9v-1z"/></svg>
              </span>
            </button>
            <button id="zoomIn" class="btn btn--compact">
              <span class="icon icon--icon-zoom-in">
                <svg class="icon__svg" viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5zm-4.5 8h4v-4h1v4h4v1h-4v4h-1v-4h-4v-1z"/></svg>
              </span>
            </button>
            <button id="downloadPdf" class="btn btn--compact" data-url="${url}">
              <span class="icon icon--icon-download">
                <svg class="icon__svg" viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M12 21l-8-9h5v-12h6v12h5l-8 9zm9-1v2h-18v-2h18z"/>
              </span>
            </button>
          </div>
          <div id="pdfViewer" style="width: 100%; height: 80vh;"></div>
          <div class="pdfControls pdfControls__bottom">
            <button id="prevPage" class="btn btn--compact">
              <span class="icon icon--icon-chevron-left">
                <svg class="icon__svg"><use xlink:href="#icon-chevron-left"></use></svg>
              </span>
            </button>
            <span id="pageInfo" class="pageInfo">Strana <span id="currentPage">1</span> z <span id="totalPages">?</span></span>
            <button id="nextPage" class="btn btn--compact">
              <span class="icon icon--icon-chevron-right">
                <svg class="icon__svg"><use xlink:href="#icon-chevron-right"></use></svg>
              </span>
            </button>
          </div>
        `;
      } else if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'odt', 'ods', 'odp'].includes(extension)) {
        const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
        return `<iframe src="${officeUrl}" style="width: 100%; height: 80vh;" frameborder="0" sandbox="allow-same-origin allow-forms allow-scripts allow-popups"></iframe>`;
      } else {
        return `<p>Preview není dostupný pro tento typ souboru. <a href="${url}" target="_blank">Stáhněte si soubor</a>.</p>`;
      }
    };

    // Funkce pro dynamické načtení PDF.js a zobrazení PDF
    const loadPdfJs = (url) => {
      currentPage = 1;
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.3.122/pdf.min.js';
      script.onload = () => {
        pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.3.122/pdf.worker.min.js';

        pdfjsLib.getDocument(url).promise.then(function (pdf) {
          pdfDoc = pdf;
          totalPages = pdf.numPages;

          document.getElementById('totalPages').textContent = totalPages;
          renderPage(currentPage);
          downLoadPdf();
          document.getElementById('prevPage').addEventListener('click', onPrevPage);
          document.getElementById('nextPage').addEventListener('click', onNextPage);
          document.getElementById('zoomIn').addEventListener('click', onZoomIn);
          document.getElementById('zoomOut').addEventListener('click', onZoomOut);
        });
      };

      script.onerror = () => {
        console.error('Failed to load PDF.js');
      };

      document.body.appendChild(script);
    };

    const renderPage = (pageNum) => {
      pdfDoc.getPage(pageNum).then(function (page) {
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        document.getElementById('pdfViewer').innerHTML = ''; // Vyčistí předchozí stránku
        document.getElementById('pdfViewer').appendChild(canvas);

        const renderContext = {
          canvasContext: context,
          viewport: viewport,
        };
        page.render(renderContext).promise.then(function () {
          document.getElementById('currentPage').textContent = pageNum;
        });
      });
    };

    const onPrevPage = () => {
      if (currentPage <= 1) {
        return;
      }
      currentPage--;
      renderPage(currentPage);
    };

    const onNextPage = () => {
      if (currentPage >= totalPages) {
        return;
      }
      currentPage++;
      renderPage(currentPage);
    };

    const onZoomIn = () => {
      scale += 0.25;
      renderPage(currentPage);
    };

    const onZoomOut = () => {
      if (scale > 0.5) {
        scale -= 0.25;
        renderPage(currentPage);
      }
    };
  }
});
